/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Divider, Grid, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { ToolsDamInformation } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { VMenu } from '../../components/shared';
import { useEffect, useState, useRef } from 'react';
import { DamsServices } from '../../services/api/dams/DamServices';
import { Edit } from '@mui/icons-material';
import { useAuthContext } from '../../context';
import ReactInputMask from 'react-input-mask';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const EntrepreneurInformation = () => {
  const url = useParams();
  const [tabs, setTabs] = useState(0);
  const [data, setData] = useState<any>();

  const navigate = useNavigate();
  const { userData } = useAuthContext();

  const utmEwRef = useRef(null);
  const utmNsRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    if (url.dam) {
      DamsServices.getById(url.dam)
        .then((result) => {
          if (result instanceof Error) {
            alert(result.message);
          } else {
            setData(result);
          }
        });
    }
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabs(newValue);
  };

  return (
    <LayoutBase
      title="Identificação do empreendedor"
      tollBar={
        <ToolsDamInformation />
      }
    >
      <Box width='100%'>
        <VMenu id={url.dam} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={tabs} onChange={handleChangeTab} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab label="INFORMAÇÕES GERAIS DO EMPREENDEDOR" {...a11yProps(0)} />
            <Tab label="INFORMAÇÕES GERAIS DO EMPREENDIMENTO" {...a11yProps(1)} />
            <Tab label="LOCALIZAÇÃO GEOGRÁFICA" {...a11yProps(2)} />
          </Tabs>
        </Box>

        {userData.nivel == 'adm' || userData.nivel == 'empresa' ? <>
          <Box flex={1} display={'flex'} padding={1} justifyContent={'end'}>
            <Button startIcon={<Edit />} variant='contained' onClick={() => navigate(`/company_organization/detalhes/${data.id_empreendimento}`)} sx={{ borderRadius: '25px' }}>Editar</Button>
          </Box>
        </> : null}
        <Box
          sx={{
            width: '100%'

          }}
        >
          <CustomTabPanel value={tabs} index={0}>
            <Box display={'flex'} flexDirection={'column'} flex={1}>
              <Grid container direction={'column'} padding={2} spacing={2}>
                <Grid container item direction={'row'} spacing={2}>
                  <Grid item xs={10} display={'flex'}>
                    <Typography variant='h5'>{'Dados do empreendedor'}</Typography>
                  </Grid>
                  <Grid item xs={12} >
                    <TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      label={'Razão Social'}
                      inputProps={{ readOnly: true }}
                      value={data?.empresa?.company_name ?? ''}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <TextField
                      fullWidth
                      label={'Nome Fantasia'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                      value={data?.empresa?.nome ?? ''}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <TextField
                      fullWidth
                      label={'CNPJ'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                      value={data?.empresa?.company_register ?? ''}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <TextField
                      fullWidth
                      label={'Telefone Geral'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                      value={data?.empresa?.phone ?? ''}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <TextField
                      fullWidth
                      label={'E-mail'}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                      value={data?.empresa?.email ?? ''}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </CustomTabPanel>
        </Box>

        <CustomTabPanel value={tabs} index={1}>
          <Box display={'flex'} flexDirection={'column'} flex={1}>
            <Grid container direction={'column'} padding={2} spacing={2}>
              <Grid container item direction={'row'} spacing={2}>
                <Grid item xs={10} display={'flex'}>
                  <Typography variant='h5'>{'Dados do empreendimento'}</Typography>
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Razão Social'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.razao_social ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'CNPJ'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.registro ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Telefone Geral'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.telefone_geral ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'E-mail'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.email_geral ?? ''}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box display={'flex'} flexDirection={'column'} flex={1}>
            <Grid container direction={'column'} padding={2} spacing={2}>
              <Grid container item direction={'row'} spacing={2}>
                <Grid item xs={10} display={'flex'}>
                  <Typography variant='h5'>{'Endereço do empreendimento'}</Typography>
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Rua'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.rua ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Número'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.numero ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Bairro'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.bairro ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Cidade'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.cidade ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'Estado'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.estado ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    fullWidth
                    label={'País'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.pais ?? ''}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={tabs} index={2}>
          <Box display={'flex'} flexDirection={'column'} flex={1}>
            <Grid container direction={'column'} padding={2} spacing={2}>
              <Grid container item direction={'row'} spacing={2}>
                <Grid item xs={10} display={'flex'}>
                  <Typography variant='h5'>{'Localização Geográfica'}</Typography>
                </Grid>
                <Grid item xs={12} >

                  <TextField
                    fullWidth
                    label={'Fuso'}
                    inputProps={{ readOnly: true }}
                    value={data?.empreendimento?.fuso_zona ?? ''}
                  />
                </Grid>
                <Grid item xs={12} >
                  <ReactInputMask
                    mask={'999999.99'}
                    value={data?.empreendimento?.utm_ew ?? ''}
                    name='utm_ew'
                  >
                    {(inputProps: any) => (
                      <TextField
                        {...inputProps} 
                        fullWidth
                        label={'Coordenadas UTM mE'}
                        inputProps={{ readOnly: true }}
                      />
                    )}
                  </ReactInputMask>
                </Grid>
                <Grid item xs={12} >
                  <ReactInputMask
                    mask={'9999999.99'}
                    value={data?.empreendimento?.utm_ns ?? ''}
                    name='utm_ns'
                  >
                    {(inputProps: any) => (
                      <TextField
                        {...inputProps} 
                        fullWidth
                        label={'Coordenadas UTM mN'}
                        inputProps={{ readOnly: true }}
                      />
                    )}
                  </ReactInputMask>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </CustomTabPanel>
      </Box>
    </LayoutBase>
  );
};